module.exports = __webpack_public_path__ + "static/media/benchmark-bkg-1.38ae415f.svg";